<div class="d-flex famnuts-decoupage cursorHelp" *ngIf="!utils.isCollectionNullOrEmpty(cellule.famillesGemrcn)">
  <div class="no-overflow" [title]="tooltip()">{{label()}}</div>
</div>
